module.exports = {

  init () {
    
    //this.mainSlider()
    this.userInfo()
    this.filterForm()
    this.toggleFilter()

  },
  
  mainSlider() {
    const swiper = new Swiper('.main-slider', {
      modules: [Navigation, Autoplay],
      direction: 'horizontal',
      loop: true,
      effect: 'slide',
      navigation: true,
      speed: 300,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  
  },
  
  
  userInfo(){
    var $allQuickView = $('.quick-view-link');
    
    $('.quick-view-link')
    .click(function(){
      $('.user').css('padding-bottom', '0');
      $allQuickView.not(this).removeClass('open');
      $(this).toggleClass('open');
      if ($(this).hasClass('open')){
        var height = $(this).children('.quick-view').height();
        $(this).parent().parent('.user').css('padding-bottom', height);
      }
    })
    
  },

  filterForm() {

    if (!document.querySelector('.filter-posts')) return

    // Display result count before filtering #UX!
    $('.filter-posts--get-count select, .filter-posts--get-count input').not('.js').on('change', function() {
      designamite.global.filterFormCount()
    }).addClass('js')

    // Display result count before filtering #UX!
    $('.filter-posts--get-count input').not('.js').on('onblur', function() {
      designamite.global.filterFormCount()
    }).addClass('js')

  },

  filterFormCount() {

    $.ajax({
      url: ajax_object.ajax_url,
      data: $('.filter-posts').serialize(),
      type: 'POST',
      success: function(data) {
        let count = parseInt(data),
            post_type = $('.filter-posts__post-type').val();
        if(post_type == 'groups'){
          $('.filter-posts__count').html(`
            ${count == 1 ? `Show ${count} group` : ''}
            ${count > 1 ? `Show ${count} ${post_type}` : ''}
            ${count <= 0 ? `No ${post_type} found` : ``}
          `)
        } else {
          $('.filter-posts__count').html(`
            ${count > 0 ? `Show ${count} ${post_type}` : ''}${count > 1 ? 's' : ''}
            ${count <= 0 ? `No ${post_type}s found` : ``}
          `)
        }
      }
    })

  },
  
  toggleFilter() {
  
    $('.filters-toggle').not('.js').on('click', function() {
      $('body').toggleClass('filters-open')
    }).addClass('js')
    
    $('.filters-close').not('.js').on('click', function() {
      $('body').removeClass('filters-open')
    }).addClass('js')
  
    $(window).on('resize', function(){
      $('body').removeClass('filters-open')
    })
  
  },

}
